import React, { useState } from "react";
import Button from "../ui/Button";
import { useToast } from "../../context/toastContext";
import { downloadFromApi } from "../../utils/downloadBlob";

export default function ShippingLabelDownload({ order }) {
    const [downloading, setDownloading] = useState(false);
    const toast = useToast();
    const download = async () => {
        if (downloading) return;
        setDownloading(true);
        try {
            await downloadFromApi(`/orders/${order.id}/shipping-label`, `shipping-label-order-${order.id}.pdf`);
        } catch (error) {
            let message = "Failed to download the shipping label. Please try again.";
            if (error.response?.data instanceof Blob) {
                try { message = JSON.parse(await error.response.data.text()).error || message; } catch { /* use default */ }
            } else if (!error.response && error.message) {
                message = error.userMessage || error.message;
            }
            toast.error(message);
        } finally {
            setDownloading(false);
        }
    };
    return (
        <div>
            <p>Printable 4 × 6 inch address label for delivery. For carrier shipping, use the postage-paid label supplied by your carrier.</p>
            <Button variant="secondary" size="sm" onClick={download} disabled={downloading} loading={downloading}>
                Download Shipping Label
            </Button>
        </div>
    );
}
